import { render, staticRenderFns } from "./statistic_product.vue?vue&type=template&id=14c5a643&scoped=true"
import script from "./statistic_product.vue?vue&type=script&lang=js"
export * from "./statistic_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c5a643",
  null
  
)

export default component.exports